'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var Box_web_styles = require('./Box.web.styles.cjs');

/**
 * This component is a styled container that displays content and actions on a single topic
 *
 * {@link https://aviary.fullscript.io/latest/components/box/web-I9X5TVv2 | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/Box/Box.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const Box = ({ intention = "neutral", children, variant = "borderless", padding = "small", customCss, ...rest })=>{
    const currentTheme = react.useTheme();
    const boxStyles = [
        Box_web_styles.box,
        Box_web_styles.padding[padding],
        variant === "bordered" && Box_web_styles.borderIntention(currentTheme, intention),
        Box_web_styles.intention(currentTheme, intention)
    ];
    return /*#__PURE__*/ jsxRuntime.jsx("section", {
        css: [
            boxStyles,
            customCss
        ],
        "data-testid": "aviary-box",
        ...rest,
        children: children
    });
};
Box.displayName = "Box";

exports.Box = Box;
//# sourceMappingURL=Box.web.cjs.map
